import { IoMdMore } from "react-icons/io";
import { LuUser } from "react-icons/lu";
import { GoDotFill } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import EmployeeDetailed from "./EmployeeDetailed";
import { isButtonElement } from "react-router-dom/dist/dom";

export default ({ item }: any) => {
  const navigate = useNavigate();
  const { setSelecteduser } = useStateSetter();


  const {setSidebarRenderView}=useStateSetter()

  return (
    <div
      onClick={() => {
       // setSidebarRenderView(<EmployeeDetailed  id={item.id} />)
      }}
      className="bg-whit shadow-sm border border-gray-200 rounded-[10px] flex  py-4  px-1 justify-between items-center"
    >
      <div className="flex">
        
        <div className=" px-2">
          <p className="font-semibold text-xs cursor-pointer">
            {item.positionTitle} 
          </p>
          <p className="font-light text-xs cursor-pointer">
            {" "}
            {item.description}{" "}
          </p>
          <div>
           
            
            <p className="inline text-xs bg-faintBlue p-1 rounded">
              Users {2}
            </p>{" "}
           
          </div>
        </div>
      </div>

      <IoMdMore size={20} className="text-textbg " />
    </div>
  );
};
